module.exports = __webpack_public_path__ + "static/media/network.71597a89.svg";